class MiniCart extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header')
    this.drawer = document.querySelector('cart-drawer')
    // Spinner rendu par header.liquid : il disparaît dès qu'un rendu (ajout au panier, etc.) a rempli le drawer.
    this.placeholder = this.firstElementChild
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this)

    // Boutons express mis en attente pendant que le drawer est fermé : insérés à son ouverture
    this.pendingExpress = null
    this.details = this.closest('details')
    if (this.details) {
      new MutationObserver(() => window.requestAnimationFrame(this.insertPendingExpress.bind(this))).observe(
        this.details,
        { attributes: true, attributeFilter: ['open'] }
      )
    }
  }

  isRendered() {
    return !this.placeholder || !this.placeholder.isConnected
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return
    observer.unobserve(this)

    // Un second rendu détruirait les boutons express (Apple Pay, PayPal…) en cours d'initialisation.
    if (this.isRendered()) {
      document.dispatchEvent(new CustomEvent('cartdrawer:opened'))
      return
    }

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        if (!this.isRendered()) {
          this.setContents(html)
          this.filterRecommendations()
        }

        document.dispatchEvent(new CustomEvent('cartdrawer:opened'))
      })
      .catch((e) => {
        console.error(e)
      })
  }

  open() {
    const detailsElement = this.drawer.querySelector('details')
    if (detailsElement.hasAttribute('open')) {
      return
    }

    this.drawer.openMenuDrawer()
  }

  renderContents(parsedState) {
    this.productId = parsedState.id
    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id)
      if (!element) return

      if (element === this) {
        this.setContents(parsedState.sections[section.id])
      } else {
        element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)
      }
    })
    this.filterRecommendations()

    this.open()
  }

  /**
   * Remplace le contenu du drawer par le rendu de la section mini-cart.
   *
   * Les boutons de paiement express (web component Shopify : Apple Pay, PayPal…) s'initialisent dès leur
   * insertion dans la page, et Shopify les retire s'il n'arrive à en afficher aucun. Insérés drawer fermé
   * (<details> sans [open], contenu non rendu), ils peuvent échouer, notamment sur Safari iOS : on voit
   * leur emplacement à l'ouverture puis ils disparaissent. Ils ne sont donc insérés qu'une fois le drawer ouvert.
   */
  setContents(html) {
    const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section')
    const express = section.querySelector('.mini-cart__dynamic-checkout-buttons')

    this.pendingExpress = null
    if (express && !this.isOpen()) {
      this.pendingExpress = express.innerHTML
      express.replaceChildren()
    }

    this.innerHTML = section.innerHTML
  }

  isOpen() {
    return !this.details || this.details.hasAttribute('open')
  }

  insertPendingExpress() {
    if (this.pendingExpress === null || !this.isOpen()) return

    const express = this.querySelector('.mini-cart__dynamic-checkout-buttons')
    if (express) express.innerHTML = this.pendingExpress
    this.pendingExpress = null
  }

  /**
   * Liste fixe de recommandations (panier vide, rendue en Liquid) : retire les produits du bloc
   * Shop the look de la page. La liste chargée par <cart-recommendations> se filtre elle-même.
   */
  filterRecommendations() {
    const root = document.getElementById('mini-cart')
    if (!root || typeof applyRecommendationExclusions !== 'function') return
    root.querySelectorAll('.cart-recommendations:not(cart-recommendations)').forEach((block) => {
      applyRecommendationExclusions(block)
      if (!block.querySelector('li')) block.remove()
    })
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ]
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
  }
}

customElements.define('mini-cart', MiniCart)
